import React, { useImperativeHandle, useState } from 'react';
import { useDispatch } from 'react-redux';

import { useI18n } from '../../../../../i18n';
import Form from '../../../general/form/Form';
import DevicePropertyPicker from '../../deviceProperties/DevicePropertyPicker';
import { ViewMode } from '../../deviceProperties/DevicePropertiesView';
import { actions } from '../../../../redux/api/reports';
import ObjectDeviceManager from '../../../share/devices/ObjectDeviceManager';
import { localStorage as storage } from 'core/app/storage';
import DummyControl from 'core/react/general/form/DummyControl';
import GroupingPicker from 'core/react/share/categories/GroupingPicker';

import './deviceRegistry.scss';

/**
 * @param {Object} props
 * @param {React.RefObject} props.customRef
 * @param {Object} [props.parameters] // { propertyIds: [], uris: [] }
 * @param {boolean} [props.disabled]
 */

function DeviceRegistry(props) {
	const { f } = useI18n();
	const dispatch = useDispatch();

	const [isAssetTypes, setIsAssetTypes] = useState(false);
	const [isGrouping, setGrouping] = useState(false);
	const [groupingId, setGroupingId] = useState(storage.get('groupingId'));

	useImperativeHandle(props.customRef, () => ({
		submit: (values) => {
			dispatch(
				actions.deviceRegistry.generate({
					parameters: { propertyIds: values.bundles, uris: values.uris, groupingId: isGrouping ? groupingId : null, isAssetTypes },
				}),
			);
		},
		clear: () => {
			dispatch(actions.deviceRegistry.exportClear());
		},
	}));

	return (
		<div className="device-registry renderer">
			<Form.ControlGroup key={50} disabled={props.disabled}>
				<Form.Control
					controlType={DevicePropertyPicker}
					controlName="bundles"
					label={f('templates restriction')}
					initialValue={props.parameters ? props.parameters.propertyIds : []}
					viewMode={ViewMode.Bundles}
				/>
				<ObjectDeviceManager
					disabled={props.disabled}
					editMode
					uris={props.parameters ? props.parameters.uris : []}
					controlName="uris"
					title={f('devices restriction')}
				/>
				<Form.Control
					controlType={Form.Control.Type.Checkbox}
					controlName="isGrouping"
					value={isGrouping}
					onChange={setGrouping}
					label={f('include device grouping')}
					disabled={props.disabled}
				/>
				<Form.Control controlType={DummyControl} controlName="grouping" value={groupingId} onChange={() => {}} hidden />
				<GroupingPicker
					disabled={props.disabled || !isGrouping}
					categoryId={groupingId}
					onChange={setGroupingId}
					cleanable={false}
				/>
				<Form.Control
					controlType={Form.Control.Type.Checkbox}
					controlName="isAssetTypes"
					value={isAssetTypes}
					onChange={setIsAssetTypes}
					label={f('include asset types')}
					disabled={props.disabled}
				/>
			</Form.ControlGroup>
		</div>
	);
}

export default DeviceRegistry;
